import { Component, OnInit, Input, ElementRef, EventEmitter, Output, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { environment } from '../../environments/environment'
import { OpportunityOfferOutputModel } from '../shared/models/OpportunityOfferOutputModel'
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { CommonService } from '../shared/providers/common.service';
import { ToastService } from '../shared/providers/toast.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from '../shared/providers/loader.service';
import { ValidationService } from '../shared/providers/validation.service';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { IPropertySearchCriteria } from '../shared/models/propertysearchcriteria';
import { OpportunityOfferListOutputModel } from '../shared/models/OpportunityOfferListOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OfferService } from '../shared/providers/offer.service';
import { OpportunityService } from '../shared/providers/opportunity.service';

export enum PropertyTabs {
  Home = 1,
  Memorandom = 2,
  Diligence = 3,
  Offer = 4,
  Inquiries = 5,
  PlaceOffer = 6,
  OfferDetail = 7,
  SendInquiryPopup = 8
}

export enum OfferStatus {
  New = 451,
  Reviewed = 452,
  CounterAccepted = 453,
  CounterDeclined = 454,
  UnderContract = 455,
  Closed = 456,
  Rejected = 457,
  OfferModified = 458,
  Draft = 459,
  OfferAccepted = 460,
  Countered = 461,
  HardContract = 462,
  OnHold = 463,
  Delete = 464,
  Resume = 465,
  Cancelled = 466,
  Declined = 467,
  NoActivitySinceLast10Days = 0,
  Reset = -1
}

@Component({
  selector: 'property-offers-list',
  templateUrl: './property-offers-list.component.html',

})
export class PropertyOffersListComponent implements OnInit {

  @Input() propertyGuid: string;
  //@Input() propertyId: number;
  @Input() propertyStatus: string;
  @Input() IsArchive: string = "0";
  @Input() IsPDeleted: boolean = false;
  user: any;
  IsLoading = false;
  isAdmin: boolean;
  fromPage: string = "PropertyView";
  placeOfferVisibility = false;
  propertyTabs = PropertyTabs;
  activeTab = this.propertyTabs.PlaceOffer;
  @ViewChild('acceptcountertemplate') accept: TemplateRef<null>;
  @ViewChild('rejectcountertemplate') reject: TemplateRef<null>;
  @ViewChild('deletetemplate') cancel: TemplateRef<null>;
  @ViewChild('declinetemplate') decline: TemplateRef<null>;
  @Output() showOffer = new EventEmitter();
  fileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
  @Input() fromPropertyDashboard = 0;
  statusList: ILookUp[];
  offerStatus = OfferStatus;
  modalRef: BsModalRef;
  showAccept: boolean = false;
  leadId: number;
  statusId: number;
  offerList: OpportunityOfferListOutputModel[];
  unChangedofferList: OpportunityOfferOutputModel[];
  GroupbyId: number = 0;
  searchText: string;
  searchCriteria: IPropertySearchCriteria;
  showPort: boolean = false;
  selectedOfferId: number;
  acceptcountertemplate: TemplateRef<any>;
  isContactPerson: boolean;
  @ViewChild(DataTableDirective, { static: true }) dtElement: DataTableDirective;
  @Output() statusChange = new EventEmitter();
  @Output() placeOffer = new EventEmitter<boolean>();
  //offerCreaterBySameUser: boolean = false;
  leadGUID: string;
  leadName: string;
  offerPrice: string;
  placedDate: Date;
  BuyerQuestionsOfferId: number = 0;
  BuyerQuestionsPropertyId: number = 0;
  modalBuyerRef: BsModalRef;
  haveaccesstoviewlocation: boolean = true;
  @Input() isFromPortfolio: boolean = false;
  constructor(private http: HttpClient,
    protected _propertyListingService: PropertyListingService,
    private router: Router,
    private modalService: BsModalService,
    public authService: AuthenticationService, private Validation: ValidationService, private _toastService: ToastService, private _propertyManagerService: PropertyManagementService, private commonService: CommonService,
    private _loader: LoaderService,
    private offerService: OfferService,
    protected activatedRoute: ActivatedRoute) {
  }

  dtOptions = {};
  offerGuid: string;
  protected readonly BASE_URL: string = environment.base_url;
  hideBroker = false;
  offers: OpportunityOfferOutputModel[];
  AssociatedBrokers = [];
  allowStatusChange = false;
  redirectLink: string;
  isPropertySeller = false;
  isStatusChanged = false;

  ngOnInit() {
    if (this.fromPropertyDashboard == 1) {
      if (this.authService.Seller()) {
        this.isPropertySeller = true;
      }
    }
    if (!this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker() && !this.authService.DataEntryStaff()) {
      this.haveaccesstoviewlocation = false;
    }
    else {
      this.haveaccesstoviewlocation = true;
    }
    this.redirectLink = this.router.url;
    this.commonService.getLookupsByTypeId(8).subscribe(response => {
      this.searchCriteria = {} as IPropertySearchCriteria;
      this.statusList = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });

      if (this.statusList.findIndex(x => x.id == OfferStatus.Closed) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Closed).description = 'Closed';
      }
      if (this.statusList.findIndex(x => x.id == OfferStatus.Cancelled) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Cancelled).description = 'Cancel';
      }
      if (this.statusList.findIndex(x => x.id == OfferStatus.Declined) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Declined).description = 'Decline';
      }
      if (this.statusList.findIndex(x => x.id == OfferStatus.Rejected) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Rejected).description = 'Reject';
      }

      if (this.statusList.findIndex(x => x.id == OfferStatus.OfferAccepted) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.OfferAccepted).description = 'Accept';
      }

      if (this.statusList.findIndex(x => x.id == OfferStatus.Countered) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Countered).description = 'Counter';
      }
      const index: number = this.statusList.findIndex(x => x.id == OfferStatus.Draft);
      if (index !== -1) {
        this.statusList.splice(index, 1);
      }

      ////this.statusListForSearch = response.map(o => {
      ////    return {
      ////        id: o.Id, name: o.Description
      ////    };
      ////});
    });

    this.isAdmin = false;
    const that = this;
    this.user = this.authService.user;
    var loggedinUserId = this.user.Id;
    var adminUserId = 0;

    let TableColums = [
      { data: 'Id' },
      { data: 'Id' },
      { data: 'NotAnsweredQustionsCount' },
      { data: 'LeadName' },
      { data: 'TradeName' },
      { data: 'LastModifiedUser' },
      { data: 'PropertyOrPortfolio' },
      { data: 'OnBehalfOf' },
      { data: 'PrimaryContactName' },
      { data: 'Price' },
      //{ data: 'OfferType' },
      { data: 'OfferDate' },
      { data: 'OfferPrice' },
      { data: 'CapRate' },
      { data: 'EarnestMoneyDeposit' },
      { data: 'DueDiligencePeriod' },
      { data: 'ClosingPeriod' },
      { data: 'StatusName' },
      { data: 'Rating' }
    ];

    let order = 5;

    if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
      adminUserId = this.user.Id;
      loggedinUserId = 0
      this.isAdmin = true;
    }
    else if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker) || this.authService.IsUserRole(this.authService.UserRole.Broker)) {
      if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
        this.hideBroker = true;
      }
      TableColums = [
        { data: 'Id' },
        { data: 'Id' },
        { data: 'NotAnsweredQustionsCount' },
        { data: 'LeadName' },
        { data: 'TradeName' },
        { data: 'LastModifiedUser' },
        { data: 'PropertyOrPortfolio' },
        { data: 'OnBehalfOf' },
        { data: 'PrimaryContactName' },
        { data: 'Price' },
        //{ data: 'OfferType' },
        { data: 'OfferDate' },
        { data: 'OfferPrice' },
        { data: 'CapRate' },
        { data: 'EarnestMoneyDeposit' },
        { data: 'DueDiligencePeriod' },
        { data: 'ClosingPeriod' },
        { data: 'StatusName' },
        { data: 'Rating' }];
      if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
        order = 4;
      }
    }
    const filter =
    {
      LoggedInUserId: loggedinUserId,
      IsFromPortfolio: this.isFromPortfolio != null ? this.isFromPortfolio : false,
      UserId: adminUserId

    }
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[order, "desc"]],
      bLengthChange: false,
      //initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        dataTablesParameters.Extra_param = filter;
        this.IsLoading = true;
        this.offers = [];
        this.offerList = [];
        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/opportunity/offersPlaced/' + this.propertyGuid,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {

            this.unChangedofferList = resp.data;
            that.offers = resp.data ? resp.data : [];
            this.AssociatedBrokers = that.offers.length > 0 ? that.offers[0]["AssociatedBrokers"] : null;
            var finalIndex = that.offers.length;
            if (this.isStatusChanged) {
              this.statusChange.emit(this.unChangedofferList);
              this.isStatusChanged = false;
            }
            if (this.GroupbyId == 0) {
              this.offerList = [];
              that.offerList.push({
                Key: '',
                Values: resp.data,
              });
            }
            else {
              this.groupData(this.GroupbyId);
            }
            if (finalIndex > 0 && (that.offers[finalIndex - 1].StatusId == 457 || that.offers[finalIndex - 1].StatusId == 464)) {
              this.placeOfferVisibility = true;
            }
            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide()
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            this.IsLoading = false;
            //if (this.AssociatedBrokers.length > 0) {
            //    if (this.AssociatedBrokers.indexOf(this.user.Id) > -1) {
            //        this.allowStatusChange = true;
            //    }
            //}
            if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker)) {
              this.allowStatusChange = true;
            }

            //if (that.user.CoBrokerId == this.user.id) {
            //  this.offerCreaterBySameUser = true;
            //}

            $(".paginate_button.first,.paginate_button.last").hide();
          });
      },
      columns: TableColums
    };

  }


  groupData(id: number) {
    if (id == 0) {
      this.onSearch('');
      this.searchText = "";
      this.GroupbyId = 0;
      this.offerList = [];
      this.offerList.push({
        Key: '',
        Values: this.unChangedofferList,
      }
      );
    }
    if (id == 1) {
      var grp = this.unChangedofferList.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.TradeName === thing.TradeName
        ))
      );
      this.offerList = [];
      grp.forEach(g =>
        this.offerList.push({
          Key: g.TradeName,
          Values: this.unChangedofferList.filter(i => i.TradeName === g.TradeName),
        }
        ));
    }
    if (id == 2) {

      var grp = this.unChangedofferList.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.LeadName === thing.LeadName
        ))
      );
      this.offerList = [];
      grp.forEach(g =>
        this.offerList.push({
          Key: g.LeadName,
          Values: this.unChangedofferList.filter(i => i.LeadName === g.LeadName),
        }
        ));
    }
    if (id == 3) {
      var grp = this.unChangedofferList.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.PropertyOrPortfolio === thing.PropertyOrPortfolio
        ))
      );
      this.offerList = [];
      grp.forEach(g =>
        this.offerList.push({
          Key: g.PropertyOrPortfolio,
          Values: this.unChangedofferList.filter(i => i.PropertyOrPortfolio === g.PropertyOrPortfolio),
        }
        ));
    }
    if (id == 4) {
      var grp = this.unChangedofferList.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.StatusName === thing.StatusName
        ))
      );
      this.offerList = [];
      grp.forEach(g =>
        this.offerList.push({
          Key: g.StatusName,
          Values: this.unChangedofferList.filter(i => i.StatusName === g.StatusName),
        }
        ));
    }
  }

  onSearch(text: string) {
    console.log(this.dtElement.dtInstance);
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  rating = [];
  starRating = 0;
  openStarRatingModal(template: TemplateRef<any>, classes: any, id: number, rating: string[], starRating: number) {
    this.idToRate = id;
    this.rating = rating;
    this.starRating = starRating;
    this.modalRef = this.modalService.show(template, { class: classes });
  }


  openPlaceOfferTab(tab: number) {

    if ((this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) || this.authService.IsUserRole(this.authService.UserRole.Broker)) {
      this.activeTab = tab;
      this.showOffer.emit(true);
    }
    else {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal or broker user to place an offer", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }

  convertUTCDateToLocalOfferDate(OfferDate: Date) {
    var newDate = new Date(OfferDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - (offset * 60 * 1000 * 60));
    return offsetTime;
  }
  statusListFilter(statusId) {
    if (this.authService.Broker() || this.authService.Admin() || this.authService.SuperAdmin() || this.isPropertySeller) {
      if (statusId == 451 || statusId == 461 || statusId == 458) {
        return this.statusList.filter(x => (x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted
          || x.id == this.offerStatus.Declined || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Cancelled));
      }
      if (statusId == 466 || statusId == 467) {
        return this.statusList.filter(x => (x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.New
          || x.id == this.offerStatus.Declined || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.HardContract));
      }
      if (statusId == 460) {
        return this.statusList.filter(x => (x.id == this.offerStatus.New || x.id == this.offerStatus.Countered
          || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Closed || x.id == this.offerStatus.Cancelled) && x.id !== statusId);
      }
      if (statusId == 455) {
        return this.statusList.filter(x => (x.id == this.offerStatus.New || x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Closed || x.id == this.offerStatus.Cancelled) && x.id !== statusId);
      }

      if (statusId == 462) {
        return this.statusList.filter(x => (x.id == this.offerStatus.New || x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.Closed || x.id == this.offerStatus.Cancelled) && x.id !== statusId);
      }

      if (statusId == 456) {
        return this.statusList.filter(x => (x.id == this.offerStatus.New || x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Cancelled) && x.id !== statusId);
      }
    }

    if ((this.authService.Principal() || this.authService.Principal1031() || this.authService.ExternalBroker()) && !this.isPropertySeller) {
      //if (statusId == 455 || statusId == 462 || statusId == 460  || statusId == 456) {
      //    return this.statusList.filter(x => (x.id == this.offerStatus.Cancel) && x.id !== statusId);
      //}
      if (statusId == 451) {
        return this.statusList.filter(x => (x.id == this.offerStatus.Countered) && x.id !== statusId);
      }

      if (statusId == 461) {
        return this.statusList.filter(x => (x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.Countered));
      }
    }
  }
  setRating(value) {
    var starList: number[] = [];
    let i = 1;
    for (i = 1; i <= 5; i++) {
      if (i <= value) {
        starList.push(1);
      }
      else {
        starList.push(0);
      }
    }
    return starList;
  }
  newRating = 0;
  idToRate = 0;
  setStar(data: any, idToRate: number) {
    //this._loader.display(true);

    this.idToRate = idToRate;
    this.rating = this.rating;

    if (data != -1) {
      this.newRating = data + 1;
    }
    else {
      this.newRating = data;
    }

    for (let i = this.newRating + 1; i <= this.rating.length; i++) {

      this.rating[i - 1] = 0;
    }
    this.offerService.UpdateLeadRating(this.idToRate, this.newRating).subscribe(res => {
      if (res) {

        this.dtElement.dtInstance.then(x => x.draw());

        this._toastService.addToast({ title: 'Success', msg: 'Offer Rating updated successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to update Offer rating', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
    this.modalRef.hide();
    //this.changeRef.detectChanges();
  }

  //statusListFilter(statusId) {

  //    if (statusId == 451 || statusId == 458 || statusId == 465) {
  //        return this.statusList.filter(x => (x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.Rejected
  //            || x.id == this.offerStatus.Countered) && x.id !== statusId);

  //    }
  //    else if (statusId == 461) {
  //        return this.statusList.filter(x => (x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.Rejected || x.id == this.offerStatus.Countered));

  //    }
  //    else if (statusId == 457) {
  //        return this.statusList.filter(x => (x.id == this.offerStatus.Delete) && x.id !== statusId);

  //    }
  //    else if (statusId == 460) {
  //        return this.statusList.filter(x => (x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Closed
  //            || x.id == this.offerStatus.UnderContract) && x.id !== statusId);

  //    }
  //    else if (statusId == 455) {
  //        return this.statusList.filter(x => (x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Closed               ) && x.id !== statusId);

  //    }
  //    else if (statusId == 462) {
  //        return this.statusList.filter(x => (x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.Closed                ) && x.id !== statusId);

  //    }
  //    else if (statusId == 456 || statusId == 464) {
  //        return null;

  //    }
  //    else if (statusId == 463) {
  //        return this.statusList.filter(x => (x.id == this.offerStatus.Resume) && x.id !== statusId);

  //    }
  //    else {
  //        return this.statusList;
  //    }

  //}

  onClose() {
    this.uploadFileModalRef.hide();
  }
  openModalForCounterAccept(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes, backdrop: true, ignoreBackdropClick: true });
    this.showAccept = true;

  }

  openModalForCounterReject(template: TemplateRef<any>, classes) {
    this.showAccept = false;
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  openModalForCancel(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  openModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.selectedOfferId = id;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  ChangeStatus() {
    var statusId = this.statusId;
    var leadId = this.leadId;
    this.user = this.authService.user;
    var userId = this.user.Id;
    this._propertyManagerService.changeOfferStatus(statusId, leadId, userId).subscribe(response => {
      ////this.bindLeadSummary();
      this.dtElement.dtInstance.then(x => x.draw());
      this._toastService.addToast({
        title: 'Success', msg:
          'Offer Status changed successfully', timeout:
          5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
      });
      this._loader.display(false);
    });
    event.preventDefault();
  }
  changeOfferStatus(statusId: number, leadId: number, leadGuid: any) {

    this.statusId = statusId;
    this.leadId = leadId;

    let currentOffer = this.offers.find(x => x.LeadId == leadId);
    if (currentOffer.StatusId == 466 || currentOffer.StatusId == 467) {
      this.offerService.CheckNewOfferExistOnCancelledOffer(currentOffer.Id, this.propertyGuid).subscribe(res => {
        if (res) {
          this._toastService.addToast({
            title: 'Error', msg: "Cannot change the status. Another offer from the same ID is progressing.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          })
        }
        else {
          this.offerStatusChange(statusId, leadGuid, leadId);
        }
      });
    }
    else {

      this.offerStatusChange(statusId, leadGuid, leadId);
    }
  }

  private offerStatusChange(statusId: number, leadGuid: any, leadId: number) {
    this.isStatusChanged = true;
    if (statusId == this.offerStatus.Countered) {
      this.router.navigate(['/counter-offer/' + leadGuid]);
    }
    if (statusId == this.offerStatus.OfferAccepted) {
      this.offerGuid = leadGuid;
      this.showAccept = true;
      this.openModalForCounterAccept(this.accept, 'panlestyle');
    }
    if (statusId == this.offerStatus.Rejected) {
      this.offerGuid = leadGuid;
      this.showAccept = false;
      this.openModalForCounterReject(this.reject, 'panlestyle');
    }
    if (statusId == this.offerStatus.Cancelled) {
      this.offerGuid = leadGuid;
      this.showAccept = false;
      this.openModalForCancel(this.cancel, '');
    }
    if (statusId == this.offerStatus.Declined) {
      this.offerGuid = leadGuid;
      this.showAccept = false;
      this.openModalForCancel(this.decline, '');
    }
    else if (statusId != this.offerStatus.Countered && statusId != this.offerStatus.OfferAccepted && statusId != this.offerStatus.Rejected && statusId != this.offerStatus.Cancelled && statusId != this.offerStatus.Declined) {
      this._loader.display(true);
      this.user = this.authService.user;
      var userId = this.user.Id;
      this._propertyManagerService.changeOfferStatus(statusId, leadId, userId).subscribe(response => {
        ////this.bindLeadSummary();
        this.dtElement.dtInstance.then(x => x.draw());
        this._toastService.addToast({
          title: 'Success', msg: 'Offer Status changed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
        this._loader.display(false);
      });
      event.preventDefault();
    }
  }

  showPortfolioProperties(id, p, index) {
    this.searchCriteria.LeadDetailsGuid = id;
    if (this.offerList[p].Values[index].PortfolioProperties == undefined || this.offerList[p].Values[index].PortfolioProperties.length == 0) {
      this._loader.display(true);
      this._propertyListingService.GetPortfolioPropertiesList(this.searchCriteria).subscribe(item => {
        item.splice(item.findIndex(x => x.IsPortfolio), 1);
        this.offerList[p].Values[index].PortfolioProperties = item;
        this.offerList[p].Values[index].ShowPortfolio = true;
        this._loader.display(false);
      })
    }
    else {
      this.offerList[p].Values[index].ShowPortfolio = !this.offerList[p].Values[index].ShowPortfolio;
    }
  }

  offerAccepted(event) {
    if (this.dtElement) {
      this.dtElement.dtInstance.then(x => x.draw());
    }
  }

  focusPlaceOffer() {
    window.scrollTo(0, 0);
    sessionStorage.setItem("PlaceOfferSource", "OfferMatrix");
    this.placeOffer.emit(true);
  }

  deleteOffers() {
    this._loader.display(true);
    var loggedinUserId = this.user.Id;
    var offerId = this.selectedOfferId;
    if (offerId > 0) {
      this._propertyManagerService.deleteOffers(offerId, loggedinUserId).subscribe(response => {
        if (response.toString() == 'true') {
          this._toastService.addToast({
            title: 'Success', msg:
              'Offer deleted successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error deleting Offer', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }
        this.dtElement.dtInstance.then(x => x.draw());
        this._loader.display(false);
      });
    }
  }

  //checkCOntactPerson() {
  //  this.commonService.GetPropertyContactPersonList(this.propertyId).subscribe(resp => {
  //    if (resp.length != 0) {
  //      let isContactUserLoggerdin = resp.find(x => x.UserId == this.user.Id);
  //      if (isContactUserLoggerdin != undefined) {
  //        this.isContactPerson = true;
  //      }
  //    }
  //  });
  //}

  ////openOfferEditPopup(template: TemplateRef<any>, OfferDetailGuid, classes) {
  ////  const config = {
  ////    ignoreBackdropClick: true,
  ////    class: classes,
  ////    keyboard: false,
  ////    backdrop: true,
  ////  }
  ////  this.leadGUID = OfferDetailGuid;
  ////  this.modalRef = this.modalService.show(template, config);
  ////}

  openOfferEditPopup(template: TemplateRef<any>, OfferDetailGuid, classes: any) {
    this.leadGUID = OfferDetailGuid;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  closeModal() {
    this.modalRef.hide();
  }

  uploadFileModalRef: BsModalRef;
  openUploadFileModal(template: TemplateRef<any>, OfferDetailGuid, leadId, classes: any) {
    this.leadGUID = OfferDetailGuid;
    let currentOffer = this.offers.find(x => x.Id == leadId);
    this.leadName = currentOffer.LeadName;
    this.offerPrice = currentOffer.OfferPrice.toString();
    this.placedDate = this.convertUTCDateToLocalOfferDate(currentOffer.OfferDate);
    this.uploadFileModalRef = this.modalService.show(template, { class: classes });
  }

  getofferPlacedUserRole(role: string) {
    if (role.toLowerCase().includes("principal") && !this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker()) {
      return "Principal";
    }
    else {
      return role;
    }
  }

  openBuyerModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.BuyerQuestionsOfferId = id;
    this.BuyerQuestionsPropertyId = index;
    this.modalBuyerRef = this.modalService.show(template, { class: classes });
  };

  SendBuyerQuestionsRemainder(offerId: number) {
    this.offerService.SendBuyerQuestionsRemainder(offerId, this.user.Id).subscribe(response => {
      if (response.toString() == 'true') {
        this._toastService.addToast({
          title: 'Success', msg:
            'Reminder sent successfully', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
      }
      else {
        this._toastService.addToast({
          title: 'Error', msg:
            'Error occured', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
      }
    });
  }

}
